module.exports = __webpack_public_path__ + "img/64.593f78ab.jpg";